import { LevelData } from '../level-data';

export const level10: LevelData = {
    name: 'The Gauntlet',
    timeLimit: 90,
    track: [
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-----  ',
        '-------',
        '-------',
        '  -----',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '---  --',
        '-------',
        '-------',
        '---S---',
        '-------',
        '-------',
        '--  ---',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '---  --',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
